module.exports = __webpack_public_path__ + "static/media/lb-cel.2acce27b.svg";